import { defineStore } from 'pinia'
import { getTotalQty } from '../../composables'
import { ProductSpecModel } from '../../model'
import { useImprintMethod } from './imprintMethod'
import { type SelectedProductSpecItem } from '../../types'

interface ProductSpecState {
  selectedList: ProductSpecModel[]
}

export const useProductSpec = defineStore('productSpec', {
  state: (): ProductSpecState => {
    return {
      selectedList: []
    }
  },
  getters: {
    getSelectedList(): ProductSpecModel[] {
      return this.selectedList
    },
    getTotalQty(): number {
      return getTotalQty(this.selectedList)
    }
  },
  actions: {
    add(item: ProductSpecModel): void {
      this.selectedList.push(item)

      const imprintMethodState = useImprintMethod();
      imprintMethodState.checkSameColor();
    },
    remove(item: ProductSpecModel): void {
      const index = this.selectedList.findIndex(
        (f) => f.objectId === item.objectId
      )

      this.removeAt(index)
    },
    removeAt(index: number): void {
      if (index >= this.selectedList.length) {
        return
      }
      if (index === -1) {
        return
      }
      this.selectedList.splice(index, 1)
      const imprintMethodState = useImprintMethod();
      imprintMethodState.checkSameColor();
    },
    exists(selectedValues: SelectedProductSpecItem[]): boolean {
      // 先把 selectedValues 转换为 string
      const selectedValuesStr = selectedValues.map(f=>`${f.name}:${f.value?.value}`).join(',');
      // 然后把现有的 selectedList 转换为 string[]
      const selectedListStr = this.selectedList.map(f=>{
        const values = f.productSpec;
        return values.map(f=>`${f.name}:${f.value?.value}`).join(',');
      });

      console.log('selectedValuesStr',selectedValuesStr)
      console.log('selectedListStr',selectedListStr)
      
      return  selectedListStr.some(f=>f===selectedValuesStr);
    },
    /**
     *
     */
    empty(): void {
      this.selectedList.splice(0)
    }
  }
})
